import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Api } from '../api';
import { UsertokenService } from '../../usertoken.service';

export const introductionGuard: CanActivateFn = async (route, state) => {
  const api = inject(Api);
  const router = inject(Router);
  const tokenservice = inject(UsertokenService)
  const redirect = await api.getViewForApiResult();
  if (redirect == "introduction") {
    const keys = Object.keys(localStorage);
    for (let i = 0; i < keys.length; i++) {
      if (tokenservice.userTokenKey != keys[i]) {
        localStorage.removeItem(keys[i]);
      }
    }


    return true
  }
  router.navigate(["/", redirect])
  return false
};